const recipe = process.env.VUE_APP_RECIPE_PATH || 'https://api.e-office.sigisystems.com';
export const baseURL = recipe + '/api/v1' || 'https://api.e-office.sigisystems.com/api/v1';
// const recipe = process.env.VUE_APP_RECIPE_PATH || 'http://127.0.0.1:8000';
// export const baseURL = recipe + '/api/v1' || 'http://127.0.0.1:8000/api/v1';
export default recipe;